import React from 'react';

import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useStateList } from 'react-use';

import { Icon } from 'components';

import {
  addWidthVariant, increaseWidthVariant, rotateY180Variant,
} from './constants';
import Options from './options';

export default function Sidebar({ ...rest }: FlexProps) {
  const { state, next: toggle } = useStateList<'full' | 'short'>(['full', 'short']);

  return (
    <motion.div
      variants={increaseWidthVariant}
      transition={{ duration: 0.5 }}
      animate={state}>
      <Flex
        zIndex={1100}
        cursor="pointer"
        bg="primary.900"
        flexDir="column"
        position="sticky"
        top={0}
        w="100%"
        minH="100vh"
        {...rest}>
        <Flex
          flex={1}>
          <Options state={state} />
        </Flex>
        <Flex
          px={6}
          h={10}
          alignItems="center"
          w="100%"
          borderTop="1px"
          flexDir="row"
          borderColor="primary.transparent"
          onClick={toggle}
          color="white">
          <motion.div
            animate={state}
            variants={rotateY180Variant}
            transition={{ duration: 0.5 }}>
            <Icon
              name="chevron-double-right"
              family="fas"
              size="sm"
            />
          </motion.div>
          <motion.div
            animate={state}
            style={{ overflow: 'hidden' }}
            variants={addWidthVariant}
            transition={{ duration: 0.5 }}>
            <Text
              ml={4}
              variant="smallRegular"
              isTruncated>Minimizar Menu
            </Text>
          </motion.div>
        </Flex>
      </Flex>
    </motion.div>
  );
}
